export function myAccount() {
    $('.category-videos-list .item').click(function () {
        let _this = $(this);
        let $videoList = $('.videos-list');

        _this.siblings().removeClass('active');
        _this.toggleClass('active');

        if (_this.hasClass('active')) {
            $('.videos-list li').hide().each((index, el) => {
                let term = el.getAttribute('data-term');

                if ($.inArray(_this.attr('data-term-slug'), term.split(',')) !== -1) {
                    $(el).show();
                }
            });

            $("html, body").animate({scrollTop: $videoList.offset().top - $('.header').innerHeight() - $('.header-banner').innerHeight() - 30}, 500);
        } else {
            $('.videos-list li').hide();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/my-account.js